import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import _ from 'lodash';
import Grid from '../../grid/Grid';
import VerticalLabelList from '../../label/VerticalLabelList';
import FieldSet from '../../fieldset/FieldSet';

import Confirm from '../../confirm/Confirm';
import '../View.css';
import EbillService from '../../../service/EbillService';

class EbillTrialSend extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      serviceOfferingId: '',
      filterTags: '',
      emailAddresses: '',
      trialSend: {},
      trialNotificationSearchServiceOfferingId: '',
      trialNotificationSearchResults: [],
      open: false,
      sendTrialEbillsErrorMessage: '',
      invalidEmailAddressesErrorMessage: '',
    };
  }

  componentDidMount() {
    const { requestedState, } = this.props;
    if (requestedState) {
      this.setState({
        serviceOfferingId: requestedState.serviceOfferingId,
        filterTags: requestedState.filterTags,
        emailAddresses: requestedState.emailAddresses,
      });
    }
  }

  onServiceOfferingChange = (event) => {
    this.setState({ serviceOfferingId: event.target.value, });
  };

  onfilterTagsChange = (event) => {
    this.setState({ filterTags: event.target.value, });
  };

  onsampleSizeChange = (event) => {
    this.setState({ sampleSize: event.target.value, });
  };

  onEmailAddressesChange = (event) => {
    this.setState({ emailAddresses: event.target.value, });
  };

  handleClickOpen = () => {
    this.setState({ open: true, });
  };

  handleClose = () => {
    this.setState({ open: false, });
  };

  onTrialNotificationSearchServiceOfferingIdChange = (event) => {
    this.setState({ trialNotificationSearchServiceOfferingId: event.target.value, });
  };

  sendTrialEbills = () => {
    this.setState({
      isLoading: true,
      trialSend: [],
      sendTrialEbillsErrorMessage: '',
      invalidEmailAddressesErrorMessage: '',
    });

    const {
      serviceOfferingId,
      filterTags,
      sampleSize,
    } = this.state;

    const emailAddressValidationRegex = /^\S+@\S+\.\S+$/;
    const emailAddressesInput = this.state.emailAddresses.split(',').map(emailAddress => emailAddress.trim());
    const invalidEmailAddresses = emailAddressesInput.filter(emailAddress => !emailAddress.match(emailAddressValidationRegex));
    if (invalidEmailAddresses.length) {
      this.setState({
        invalidEmailAddressesErrorMessage: `Input contains one or more invalid email addresses: "${invalidEmailAddresses.join('", "')}"`,
        isLoading: false,
      });
      this.handleClose();
      return;
    }

    const tags = filterTags.trim().length === 0 ? [] : filterTags.split(',').map(filterTag => filterTag.trim());

    const request = {
      emailAddresses: emailAddressesInput,
      filterTags: tags,
      sampleSize,
    };

    EbillService.triggerTrialEbills(serviceOfferingId.trim(), request)
      .then(response => response.data)
      .then(response => {
        this.setState({
          trialSend: response.data,
        });
      })
      .catch((err) => {
        this.setState({
          sendTrialEbillsErrorMessage: `Saw an error attempting to send trial ebills for Service Offering ID: ${serviceOfferingId}: ${err.message}`,
        });
      })
      .finally(() => {
        this.handleClose();
        this.setState({
          isLoading: false,
          serviceOfferingId: '',
          filterTags: '',
          emailAddresses: '',
        });
      });
  };

  searchTrialNotifications = () => {
    const {
      trialNotificationSearchServiceOfferingId,
    } = this.state;

    const searchFields = {};
    if (trialNotificationSearchServiceOfferingId) {
      searchFields.serviceOfferingId = trialNotificationSearchServiceOfferingId;
    }

    this.setState({
      trialNotificationSearchResults: [],
    });

    EbillService.searchTrialNotifications(searchFields)
      .then(response => response.data)
      .then(response => {
        this.setState({
          trialNotificationSearchResults: response.trialNotifications || [],
        });
      })
      .catch((err) => {
        throw Error(err);
      });
  };

  renderTrialSend = () => {
    const { trialSend = {}, } = this.state;
    const formattedTrialSend = Object.keys(trialSend)
      .filter(key => !!trialSend[key])
      .reduce((obj, key) => {
         
        obj[_.startCase(key)] = trialSend[key];
        return obj;
      }, {});
    const items = VerticalLabelList.toList(formattedTrialSend);
    const exclusions = [ 'Notifications', ];

    const notifications = trialSend.notifications || [];
    const notificationHeaders = [
      {
        value: 'emailAddress',
        display: 'Email Address',
      },
      {
        value: 'billId',
        display: 'Bill Id',
      },
      {
        value: 'status',
        display: 'Status',
      },
      {
        value: 'exception',
        display: 'Exception',
      },
    ];
    const notificationRows = notifications.map(notification => ({
      value: [
        notification.emailAddress,
        notification.billId,
        notification.status,
        notification.exception,
      ],
    }));

    return (
      <div>
        {/* <br />
        <hr /> */}
        <br />
        <div>
          <FieldSet title="Trial Send" style={{ maxHeight: '400px', }}>
            <VerticalLabelList items={items} exclusions={exclusions} />
            {/* <br /> */}
            <FieldSet title='Trial eBill Notifications'>
              <Grid
                headers={notificationHeaders}
                rows={notificationRows}
              />
            </FieldSet>
          </FieldSet>
        </div>
        <br />
      </div>
    );
  };

  renderTrialNotificationSearch = () => {
    const {
      trialNotificationSearchServiceOfferingId,
    } = this.state;

    return (
      <div>
        <br />
        <hr />
        <br />
        <div className="basic-input-content">
          <Form.Group className="mb-3" controlId="formBasicSoid">
            <Form.Text>
              Search recently triggered Trial Notifications. Service Offering ID field can be left blank.
            </Form.Text>
            <br />
            <Form.Label>Service Offering ID:</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter a service offering ID"
              value={trialNotificationSearchServiceOfferingId}
              onChange={this.onTrialNotificationSearchServiceOfferingIdChange}
            />
          </Form.Group>
          <br />
          <Row className="mt-3">
            <Col>
              <Button
                variant="success"
                className="ms-2"
                onClick={this.searchTrialNotifications}
              >
                Search Trial Notifications
              </Button>
            </Col>
          </Row>
        </div>
        {this.renderTrialNotificationSearchResults()}
      </div>
    );
  };

  renderTrialNotificationSearchResults = () => {
    const {
      trialNotificationSearchResults,
    } = this.state;

    const searchResultHeaders = [
      {
        value: 'emailAddress',
        display: 'Email Address',
      },
      {
        value: 'status',
        display: 'Status',
      },
      {
        value: 'exception',
        display: 'Exception',
      },
      {
        value: 'serviceOfferingId',
        display: 'Service Offering Id',
      },
      {
        value: 'createdAt',
        display: 'Created At',
      },
      {
        value: 'triggeredAt',
        display: 'Triggered At',
      },
      {
        value: 'sentAt',
        display: 'Sent At',
      },
      {
        value: 'failedAt',
        display: 'Failed At',
      },
      {
        value: 'billId',
        display: 'Bill Id',
      },
      {
        value: 'enrollmentId',
        display: 'Enrollment Id',
      },
    ];
    const searchResultRows = trialNotificationSearchResults.map(notification => ({
      value: [
        notification.emailAddress,
        notification.status,
        notification.exception,
        notification.serviceOfferingId,
        notification.createdAt,
        notification.triggeredAt,
        notification.sentAt,
        notification.failedAt,
        notification.billId,
        notification.enrollmentId,
      ],
    }));

    return (
      <div>
        <br />
        <FieldSet title='Trial eBill Notification Search Results'>
          <Grid
            headers={searchResultHeaders}
            rows={searchResultRows}
          />
        </FieldSet>
      </div>
    );
  };

  render() {
    const {
      serviceOfferingId, filterTags, sampleSize, emailAddresses, isLoading, open, sendTrialEbillsErrorMessage,
      invalidEmailAddressesErrorMessage,
    } = this.state;

    return (
      <div className="content">
        <Form.Group className="mb-3" controlId="formBasicSoid">
          <Form.Text>You can use this feature to send a small number of randomly selected notifications to a list
            of email addresses that you provide.
          </Form.Text>
          <br />
          <Form.Label>Service Offering ID:</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter a service offering ID"
            value={serviceOfferingId}
            onChange={this.onServiceOfferingChange}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicSampleSize">
          <Form.Label>Sample Size:</Form.Label>
          <Form.Control
            type="number"
            defaultValue={10}
            placeholder="Enter sample size (optional)"
            value={sampleSize}
            onChange={this.onsampleSizeChange}
          />
          <Form.Text>The max amount of emails to send, defaults to 10.</Form.Text>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicfilterTags">
          <Form.Label>Filter Tags:</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter filter tags (optional)"
            value={filterTags}
            onChange={this.onfilterTagsChange}
          />
          <Form.Text>Please enter filter tags separated by commas. Spaces are okay.</Form.Text>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicSoid">
          <Form.Control
            type="text"
            placeholder="Email addresses"
            value={emailAddresses}
            onChange={this.onEmailAddressesChange}
          />
          <Form.Text>Please enter email addresses separated by commas. Spaces are okay.</Form.Text>
        </Form.Group>
        <br />
        <div className="basic-input-content">
          <Row className="mt-3">
            <Col>
              {sendTrialEbillsErrorMessage && <p className="small text-danger">{sendTrialEbillsErrorMessage}</p>}
              {invalidEmailAddressesErrorMessage && <p className="small text-danger">{invalidEmailAddressesErrorMessage}</p>}
              <Button
                variant="success"
                className="ms-2"
                onClick={this.handleClickOpen}
                disabled={!serviceOfferingId || !emailAddresses}
              >
                Send Trial eBills
              </Button>
              <Confirm
                isLoading={isLoading}
                title="Send Trial eBills"
                content={filterTags.length > 0 ? `Are you sure you want to send out Trial eBills for Service Offering ${serviceOfferingId} using Filter Tags ${filterTags}?`
                  : `Are you sure you want to send out eBills for Service Offering ${serviceOfferingId}?`}
                open={open}
                onClose={this.handleClose}
                onYes={this.sendTrialEbills}
                onNo={this.handleClose}
              />
            </Col>
          </Row>
        </div>
        {this.renderTrialSend()}
        {this.renderTrialNotificationSearch()}
      </div>
    );
  }
}

EbillTrialSend.defaultProps = {
  requestedState: undefined,
};

EbillTrialSend.propTypes = {
  requestedState: PropTypes.instanceOf(Object),
};

export default EbillTrialSend;
